import React, { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

//import localization librabries
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import localization translated json files
import PageLoader from "./components/page_loader.js";

import translationsResources from "./static_assets/localization/resource.ts";
import languageCodes from "./static_assets/localization/languageCodes.json";

const AnimatedRoutes = React.lazy(() => import("./routing/animate_routing.js"));

//initialize locatlication in app
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: translationsResources(),
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

i18n.languages = languageCodes;

function App() {
  //set user language
  useEffect(() => {
    const user_language = localStorage.getItem("language");
    if (user_language) {
      i18n.changeLanguage(user_language);
    }
  }, []);

  return (
    //wrap app with HelmetProvide for Meta Data integration
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <AnimatedRoutes />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
